/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { isPresent } from '@ember/utils';
import { ESPS } from 'cio/utils/email-service-providers';

const espHelpItems = Object.freeze(Object.values(ESPS).filter((info) => isPresent(info.documentationUrl)));

export default class TipsAndResources extends Component {
  espHelpItems = espHelpItems;
}
